
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Vor und während der Wechseljahre ändert sich vieles im Körper der Frau. Zu Beginn dieser Zeit fällt zuerst der Progesteronspiegel ab, danach sinkt auch der Östrogenspiegel. Da sich das Östrogen auch auf die Temperaturregulierung im Körper auswirkt, kann es zu nächtlichen Hitzewallungen und Schweissausbrüchen kommen. Durch den Mangel an Östrogen bildet der Körper weniger Melatonin, was das Einschlafen wiederum erschwert. Östrogene sind aber nicht nur für einen guten Schlaf wichtig, sie haben auch einen positiven Einfluss auf das psychische Befinden und beeinflussen die Gedächtnisfunktion und das Herz-Kreislauf-System.`}<br /><br />{`
Fühlen sich Frauen während der Wechseljahre tagsüber reizbar und gestresst, wirkt sich das auch auf den Schlaf aus. Doch nicht nur die hormonelle Umstellung, auch Veränderungen im Alltag einer Frau spielen eine Rolle, wenn der Schlaf schlechter wird. `}<M mdxType="M">{`Geschätzt jede fünfte Frau erkrankt während dieser herausfordernden Lebensjahre an einer Depression oder einer Angststörung.`}</M></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;